import { render, staticRenderFns } from "./GlobalStyleBlock.vue?vue&type=template&id=5e877588"
import script from "./GlobalStyleBlock.vue?vue&type=script&lang=js"
export * from "./GlobalStyleBlock.vue?vue&type=script&lang=js"
import style0 from "./GlobalStyleBlock.vue?vue&type=style&index=0&id=5e877588&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports